module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "foo"
  }, [_c('H1', [_vm._v("Cenovnik")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "button button-outline",
    staticStyle: {
      "width": "150px"
    },
    style: (_vm.getModuleStyle(0)),
    on: {
      "click": function($event) {
        return _vm.setTab(0)
      }
    }
  }, [_vm._v("Regioni")]), _vm._v(" "), _c('button', {
    staticClass: "button button-outline",
    staticStyle: {
      "width": "150px"
    },
    style: (_vm.getModuleStyle(1)),
    on: {
      "click": function($event) {
        return _vm.setTab(1)
      }
    }
  }, [_vm._v("Adrese")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "input",
    staticStyle: {
      "width": "90%",
      "border-radius": "10px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Pretraga",
      "name": "users"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.tabIndex === 0) ? _c('button', {
    staticClass: "button button-outline",
    staticStyle: {
      "width": "150px",
      "background": "#2b542c",
      "color": "white"
    },
    on: {
      "click": _vm.openAddRegion
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" Dodaj region")]) : _vm._e(), _vm._v(" "), (_vm.tabIndex === 1) ? _c('button', {
    staticClass: "button button-outline",
    staticStyle: {
      "width": "150px",
      "background": "#2b542c",
      "color": "white"
    },
    on: {
      "click": _vm.openAddAddress
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" Dodaj adresu")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _c('br')], 1), _vm._v(" "), (_vm.tabIndex === 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed",
    staticStyle: {
      "margin-bottom": "100px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredRegions), function(item) {
    return _c('tr', {
      staticStyle: {
        "color": "white",
        "background-color": "#4E5066 !important"
      }
    }, [_c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_vm._v(_vm._s(item.price))]), _vm._v(" "), _c('td', [_c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "cornflowerblue"
      },
      attrs: {
        "type": "button",
        "placeholder": "Izmeni",
        "name": "Izmeni",
        "value": "Izmeni"
      },
      on: {
        "click": function($event) {
          return _vm.openEditRegion(item)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "#843534"
      },
      attrs: {
        "type": "button",
        "placeholder": "Obriši",
        "name": "Obriši",
        "value": "Obriši"
      },
      on: {
        "click": function($event) {
          return _vm.deleteRegion(item)
        }
      }
    })])])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), (_vm.tabIndex === 1) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed",
    staticStyle: {
      "margin-bottom": "100px"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Ime")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Grad")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Region")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Cena")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "100px",
      "color": "white"
    }
  }, [_vm._v("Izmeni")]), _vm._v(" "), (_vm.visibleDel()) ? _c('th', {
    staticStyle: {
      "width": "100px",
      "color": "white"
    }
  }, [_vm._v("Obriši")]) : _vm._e()])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredAddresses), function(item) {
    return _c('tr', {
      staticStyle: {
        "color": "white",
        "background-color": "#4E5066 !important"
      }
    }, [_c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_vm._v(_vm._s(item.city))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_vm._v(_vm._s(item.neighborhood.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_vm._v(_vm._s(item.neighborhood.price))]), _vm._v(" "), _c('td', [_c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "cornflowerblue"
      },
      attrs: {
        "type": "button",
        "placeholder": "Izmeni",
        "name": "Izmeni",
        "value": "Izmeni"
      },
      on: {
        "click": function($event) {
          return _vm.openEditAddress(item)
        }
      }
    })]), _vm._v(" "), (_vm.visibleDel()) ? _c('td', [_c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "#843534"
      },
      attrs: {
        "type": "button",
        "placeholder": "Obriši",
        "name": "Obriši",
        "value": "Obriši"
      },
      on: {
        "click": function($event) {
          return _vm.deleteAddress(item)
        }
      }
    })]) : _vm._e()])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), _c('edit-region-modal', {
    attrs: {
      "show": _vm.openEditRegionValue,
      "region": _vm.regionToEdit
    }
  }), _vm._v(" "), _c('edit-address-modal', {
    attrs: {
      "show": _vm.openEditAddressValue,
      "address": _vm.addressToEdit
    }
  }), _vm._v(" "), _c('edit-region-modal', {
    attrs: {
      "show": _vm.openAddRegionValue
    }
  }), _vm._v(" "), _c('edit-address-modal', {
    attrs: {
      "show": _vm.openAddAddressValue,
      "regions": _vm.regions
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Ime")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Cena")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "100px",
      "color": "white"
    }
  }, [_vm._v("Izmeni")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "100px",
      "color": "white"
    }
  }, [_vm._v("Obriši")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-684369f8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Price/Price.vue
// module id = 490
// module chunks = 1